import React, { useEffect, useMemo, useState } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { BossModeTrack } from './types';
import ReorderResizeTable from 'components/ReorderResizeTable';
import {
  CUSTOM_COL_SIZES,
  HEADING_TRANSLATIONS,
  TABLE_COLUMNS,
} from './components/BossModeStatsTableCells/data';
import useQueryParams from 'hooks/useQueryParams';
import api from 'api';
import { BODY_CONTENT_GENERATE } from './components/BossModeStatsTableCells';
import NumberOfResultsPerPageFilter from 'components/NumberOfResultsPerPageFilter';
import useNumberOfResultsPerPage from 'hooks/useNumberOfResultsPerPage';

import './BossModeStats.styles.scss';

type BossModeStatsProps = {
  className?: string;
};

const BossModeStats: React.FC<BossModeStatsProps> = (props) => {
  const { className } = props;

  const [isLoading, setIsLoading] = useState(false);
  const [items, setItems] = useState<BossModeTrack[]>([]);
  const [totalPages, setTotalPages] = useState(0);

  const { limit, updateLimit } = useNumberOfResultsPerPage();

  const {
    params: { page },
  } = useQueryParams<{ page: string }>();
  const { t } = useTranslation();

  const classes = classNames('boss-mode-stats', className);

  const renderedContent = useMemo(
    () =>
      TABLE_COLUMNS.reduce(
        (acc, col) => ({
          ...acc,
          [col]: (stat: BossModeTrack) => BODY_CONTENT_GENERATE[col](stat),
        }),
        {},
      ),
    [],
  );

  useEffect(() => {
    (async () => {
      try {
        setIsLoading(true);
        const {
          data: { items, totalPages },
        } = await api.portfolio.admin.getBossModeTracks({
          $page: page,
          $limit: limit,
        });
        setItems(items);
        setTotalPages(totalPages);
      } catch (e) {
        return;
      } finally {
        setIsLoading(false);
      }
    })();
  }, [page, limit]);

  return (
    <div className={classes}>
      <div>
        <h1>{t('bossModeMetrics')}</h1>
        <NumberOfResultsPerPageFilter limit={limit} updateLimit={updateLimit} />
      </div>

      <ReorderResizeTable
        columns={TABLE_COLUMNS}
        data={items}
        isDragDisabled
        isDataLoading={isLoading}
        totalPages={totalPages}
        customSizes={CUSTOM_COL_SIZES}
        headingTranslations={HEADING_TRANSLATIONS}
        tableContentTransformations={renderedContent}
      />
    </div>
  );
};

export default BossModeStats;
